import { api } from "../client";

export interface AuthUser {
  id: string;
  email: string;
  display_name: string;
  default_company_id: string | null;
  /** True when this user holds hub-wide admin rights (Settings → Users). */
  is_admin: boolean;
}

export interface LoginInput {
  email: string;
  password: string;
}

export interface SignupInput extends LoginInput {
  display_name: string;
}

export const authApi = {
  me: () => api<{ user: AuthUser | null }>("/v1/auth/me"),
  login: (input: LoginInput) =>
    api<{ user: AuthUser; session_id: string }>("/v1/auth/login", {
      method: "POST",
      body: input,
    }),
  signup: (input: SignupInput) =>
    api<{ user: AuthUser; session_id: string }>("/v1/auth/signup", {
      method: "POST",
      body: input,
    }),
  logout: () => api<{ ok: true }>("/v1/auth/logout", { method: "POST" }),
  logoutEverywhere: () =>
    api<{ ok: true }>("/v1/auth/logout-everywhere", { method: "POST" }),
  changePassword: (input: { current: string; next: string }) =>
    api<{ ok: true }>("/v1/auth/password", { method: "POST", body: input }),
  /**
   * Returns a short-lived bearer that the WS `hello` envelope carries as its
   * `session_token` field. The hub mints this from the cookie session and
   * names the field `session_token` in the JSON response — the SPA stripped
   * the prefix on read until 2026-05-10, which silently broke the WS.
   */
  wsToken: () =>
    api<{ session_token: string; expires_at: number }>("/v1/auth/ws-token"),
};
